module.exports = __webpack_public_path__ + "img/type10100.133b2c53.png";